<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader" />
      <rule-game :title="ruleTitle.rule" :value="ruleGame" />
      <rule-game :title="ruleTitle.payTable" :value="rulePaytable" />
      <rule-game :title="ruleTitle.playerDraw" :value="rulePlayerdraw" />
      <rule-game :title="ruleTitle.bankerDraw" :value="ruleBankerdraw" />
      <rule-game :title="ruleTitle.part" :value="rulePart" />
      <rule-game :title="ruleTitle.noBet" :value="ruleNobet" />
      <rule-game :title="ruleTitle.bet" :value="ruleBet" />
      <rule-game :title="ruleTitle.beadRoad" :value="ruleBeadroad" />
      <rule-game :title="ruleTitle.bigRoad" :value="ruleBigroad" />
      <rule-game :title="ruleTitle.bigEye" :value="ruleBigeye" />
    </div>
  </div>
</template>

<script>
import Bcrbanner from '../../assets/gamerule/baccarat/Brc_Banner.png';
import Fsrule from '../../assets/gamerule/fruitslot/fruit_text1.png';
import Bcrcard from '../../assets/gamerule/dt/Order Card.png';
import Bcrpay from '../../assets/gamerule/baccarat/rule deal banker.png';
import Bcrplayer from '../../assets/gamerule/baccarat/rule deal player.png';
import Bcrbanker from '../../assets/gamerule/baccarat/Pay ratio.png';
import Bcrasset from '../../assets/gamerule/baccarat/Info Page 1 Top.png';
import Bcrasset2 from '../../assets/gamerule/baccarat/Group 600.png';
import Bcrnobet from '../../assets/gamerule/baccarat/Free hand.png';
import Bcrnobet2 from '../../assets/gamerule/baccarat/Skip.png';
import Bcrbet from '../../assets/gamerule/baccarat/Info Page 2 left.png';
import Bcrbet2 from '../../assets/gamerule/baccarat/Info Page 2 right.png';
import Bcrbeadroad from '../../assets/gamerule/baccarat/Bead Road.png';
import Bcrbigroad from '../../assets/gamerule/baccarat/Big Road.png';
import Bcrbigeye from '../../assets/gamerule/baccarat/Big Eye Road.png';

export default {
  name: 'rule_dragontiger',
  data() {
    return {
      ruleHeader: {
        gameName: 'บาคาร่า',
        boardImg: Bcrbanner,
      },
      ruleTitle: {
        payTable: 'อัตราจ่าย',
        playerDraw: 'กฎการจั่วไพ่ฝั่งผู้เล่น',
        bankerDraw: 'กฎการจั่วไพ่ฝั่งเจ้ามือ',
        part: 'ส่วนประกอบ',
        noBet: 'รอบที่ไม่มีการเดิมพัน',
        bet: 'วิธีการเดิมพัน',
        beadRoad: 'ตาราง Bead Road',
        bigRoad: 'ตาราง Big Road',
        bigEye: 'ตาราง Big Eye Road',
      },
      ruleGame: [
        {
          image: Fsrule,
          type: 'imageNoborderSlot',
          class: 'w-30 ml-3',
        },
        {
          type: 'imageTextBcr',
          text: 'คุณเคยสงสัยไหมว่าทำไม',
          textCol: ' Baccarat ',
          text2: 'ถึงอ่านว่า บาคาร่าทั้งๆที่มีตัว \'t\' อยู่ท้ายสุด เพราะ \'t\' นั่นหมายถึง \'ศูนย์\' เช่นเดียวกันกับแต้มไพ่บาคาร่า แต้มต่างๆเรียงมาตั้งแต่ 10,J,Q,K และอื่นๆ ตามมาโดยไพ่แต้ม 10 มีค่าเท่ากับศูนย์ และการนับแต้มไพ่จะเอาแค่ A-9 เท่านั้น โดยไพ่ A มีค่าเท่ากับ 1 สมมติว่ามีไพ่ 3 ใบในมือ 4-5-9 ตามลำดับแต้มไพ่ทั้งหมดจะเท่ากับ 8 หรือ 18 ลบด้วย 10 เพราะเลข 10 มีค่าเท่ากับ 0',
          image: Bcrcard,
          class: 'w-70',
        },
      ],
      rulePaytable: [
        {
          type: 'imageTextBcr2',
          text: 'ในเกมส์ของบาคาร่านั้นจะแบ่งออกเป็น 2 ฝั่งได้แก่',
          textCol: ' ฝั่งของผู้เล่น ',
          text2: 'และ',
          textCol2: ' ฝั่งของเจ้ามือ ',
          text3: 'โดยคุณสามารถเดิมพันผลการแข่งขันของทั้ง 2 ฝั่งได้ทั้งหมด 5 รายการดังตารางต่อไปนี้',
          image: Bcrpay,
          class: 'w-50',
        },
      ],
      rulePlayerdraw: [
        {
          type: 'imageTextBcr3',
          text: 'หากผลรวมของ',
          textCol: ' ผู้เล่น ',
          text2: 'น้อยกว่าหรือเท่ากับ 5 ผู้เล่นจะจั่วไพ่ใบที่สามดังตารางต่อไปนี้',
          textCol2: ' ฝั่งของเจ้ามือ ',
          text3: 'โดยคุณสามารถเดิมพันผลการแข่งขันของทั้ง 2 ฝั่งได้ทั้งหมด 5 รายการดังตารางต่อไปนี้',
          image: Bcrplayer,
          class: 'w-50',
        },
      ],
      ruleBankerdraw: [
        {
          type: 'imageTextBcr4',
          text: 'หาก',
          textCol: 'ผู้เล่น',
          text2: 'ไม่ได้จั่วไพ่ใบที่สาม มือของ',
          textCol2: 'เจ้ามือ',
          text3: 'จะไม่จั่วหากมีแต้ม 6 แต้มขึ้นไป และจั่วใบที่สามหากมีแต้มน้อยกว่า แต่ถ้า',
          textCol3: 'ผู้เล่น',
          text4: 'จั่วใบที่สาม จะตัดสินด้วยกฎของเจ้ามือว่า',
          textCol4: 'เจ้ามือ',
          text5: 'จะจั่วใบที่สามหรือไม่',
          image: Bcrbanker,
          class: 'w-50',
        },
      ],
      rulePart: [
        {
          type: 'dtPart',
          image: Bcrasset,
          image2: Bcrasset2,
          text1: '1. ประเภทเหรียญในการเดิมพัน',
          text2: '2. ค่าเงินสูงสุดและต่ำสุดในการเดิมพันแต่ละรอบ',
          text3: '3. ประวัติการออกไพ่ในแต่ละรอบ',
          text4: '4. โต๊ะสำหรับวางเหรียญเดิมพัน',
          text5: '5. ค่าเงินเดิมพันทั้งหมดในแต่ละรอบ',
          text6: '6. ปุ่มสำหรับกดแต่ละประเภท',
          text7: '- ปุ่มเดิมพันซ้ำ ใช้สำหรับการเดิมพันประเภทเดิมซ้ำ',
          text8: '- ปุ่มยกเลิก ใช้สำหรับยกเลิกทั้งหมด',
          text9: '- ปุ่มตกลง ใช้สำหรับการยืนยันการเดิมพันทั้งหมด',
          text10: '7. ตารางสถิติ บันทึกประวัติการเล่น 50 รอบ',
          text11: '8. กราฟสรุปสถิติ รูปแบบทั้งหมด',
        },
      ],
      ruleNobet: [
        {
          type: 'twoImageText',
          image: Bcrnobet,
          image2: Bcrnobet2,
          text: 'ในกรณีเข้าเล่นเกมส์ครั้งแรก ประวัติการเล่นจะยังไม่มี ดังนั้นจึงอาจจะทำให้ผู้เล่นไม่สามารถรู้รูปแบบการออกในตาถัดไปได้ ตัวเกมส์จึงมีส่วนของการเล่นแบบไม่มีการเดิมพัน 5 รอบ เพื่อให้ผู้เล่นสามารถคาดการณ์รูปแบบที่จะออกในตาถัดไปได้ และมีการแสดงการเล่นจริงใน 5 รอบที่ไม่มีการเดิมพัน โดยผู้เล่นสามารถข้ามในส่วนนี้ได้โดยการกดปุ่ม ข้าม',
        },
      ],
      ruleBet: [
        {
          type: 'imageTextBcr5',
          image: Bcrbet,
          image2: Bcrbet2,
          text: 'เมื่อเริ่มเกมส์ ให้ทำการเดิมพันโดยเลือกเหรียญเดิมพันตามราคาที่ต้องการ โดยการเดิมพันจะแบ่งออกเป็น 5 รายการ ได้แก่',
          textCol: ' เจ้ามือ',
          text2: ',',
          textCol2: ' เสมอ',
          text3: ',',
          textCol3: ' ผู้เล่น',
          text4: ',',
          textCol4: ' เจ้ามือออกคู่ และ ผู้เล่นออกคู่',
          text5: ' ให้เลือกเดิมพันตามรายการที่ต้องการ เมื่อเดิมพันเรียบร้อยแล้วให้กดปุ่มยืนยัน หรือถ้าต้องการยกเลิกการเดิมะพันให้กดปุ่มยกเลิกการเดิมพัน',
        },
      ],
      ruleBeadroad: [
        {
          type: 'imageTextBcr6',
          text: 'เป็นตารางที่เข้าใจง่ายและบัยทึกง่ายที่สุด ในตารางจะมี 6 แถวแนวนอนไว้เพื่อเปรียบเทียบกัน วิธีการบันทึกคือเริ่มต้นที่มุมซ้ายบน ถ้าเป็นฝั่ง',
          textCol: ' ผู้เล่นจะใส่สีฟ้า ',
          text2: 'ส่วนถ้าเป็นฝั่ง',
          textCol2: ' เจ้ามือจะใส่สีแดง  ',
          text3: 'และ',
          textCol3: ' เสมอจะเป็นสีเขียว ',
          text4: 'บันทึกตามลำดับแนวตั้ง',
          image: Bcrbeadroad,
          class2: 'w-70',
          textCol4: 'สีฟ้า',
          text5: ' = ผู้เล่นชนะ',
          textCol5: 'สีแดง',
          text6: ' = เจ้ามือชนะ',
          textCol6: 'สีเขียว',
          text7: ' = เสมอ',
        },
      ],
      ruleBigroad: [
        {
          type: 'imageTextDt3',
          image: Bcrbigroad,
          class: 'w-70',
          text: 'ตารางใหญ่สุดหรือ Big Road คือช่องตารางการแสดงผลการชนะในแต่ละรอบ โดย',
          textCol: ' สีฟ้า หมายถึงฝั่งผู้เล่นชนะ',
          text2: ',',
          textCol2: ' สีแดง หมายถึงฝั่งเจ้ามือชนะ ',
          text3: ' และ',
          textCol3: 'สีเขียวคลาดกลางจะหมายถึงเสมอ ',
          text4: 'โดยจะมีการเปลี่ยนแถวใหม่ก็ต่อเมื่อมีการเปลี่ยนแปลงฝั่งชนะ',
        },
      ],
      ruleBigeye: [
        {
          type: 'imageTextBcr7',
          image: Bcrbigeye,
          class2: 'w-70',
          textCol: 'สีน้ำเงิน',
          text: ' = มีการเปลี่ยนแปลงรูปแบบ เกิดขึ้นบ่อยครั้ง',
          textCol2: 'สีแดง',
          text2: ' = มีการซ้ำรูปแบบเดิมๆ เกิดขึ้นเรื่อยๆ',
          text3: 'ตาราง Big Eye Road เป็นอีกหนี่งเทคนิคของนักพนันชาวจีน ที่ใช้เป็นเหมือนตัววัด เพื่อดูว่าผลลัพธ์ของ',
          textCol3: ' ฝั่งผู้เล่น ',
          text4: 'และ',
          textCol4: ' ฝั่งเจ้ามือ ',
          text5: 'มีรูปแบบซ้ำในรูปแบบเดิมมากน้อยแค่ไหนในตอนนี้ โดยถ้า',
          textCol5: ' สีแดง ',
          text6: 'ในตารางเยอะ แสดงว่ามีรูปแบบการเล่นที่สมดุลระหว่าง',
          textCol6: 'ผู้เล่น',
          text7: 'และ',
          textCol7: 'เจ้ามือ',
          text8: ' แต่ถ้า',
          textCol8: 'สีฟ้า',
          text9: ' เยอะในตาราง แสดงว่ามีรูปแบบที่วุ่นวาย ไม่แน่นอน',
        },
      ],
    };
  },
};
</script>
